/** Preis A2: Gründe, warum ein Kanal kein Ziel hat (Backend `ChannelTarget.sperre`), im Klartext. */
const TEXT: Record<string, string> = {
  kv_kanal_unklar: 'Plus Versand: Basis leitet an kein oder mehrere Portale weiter',
  kv_marker_fremd: 'Plus Versand: Marker gehört zu einem anderen Portal',
  kv_unbekannt: 'Plus Versand: Versandbetrag unbekannt oder Ernte älter als 48 h',
  kv_uneinheitlich: 'Plus Versand: eBay-Angebote mit unterschiedlichem Versand',
  kv_kanal_ohne_quelle: 'Plus Versand: für diesen Kanal gibt es keinen Versandbetrag',
  kv_amazon_exkl: 'Plus Versand bei Amazon: kein Versandbetrag bekannt',
  nenner_ungueltig: 'Marge zu hoch: Kosten + Marge ≥ 100 % – kein Preis',
  exkl_preis_nicht_positiv: 'Plus Versand: Versand ist höher als der Gesamtpreis',
}

export function a2SperreText(grund: string | null | undefined): string | null {
  if (!grund) return null
  return TEXT[grund] ?? grund
}

const PORTAL: Record<string, string> = { shopify: 'Shopify', ebay: 'eBay', metro: 'Metro', kaufland: 'Kaufland', base: 'Basis' }
const AMAZON_UNBEKANNT: Record<string, string> = {
  amazon_versand_unbekannt: 'Versand des Amazon-Angebots unbekannt',
  amazon_plus_versand: 'Amazon-Angebot mit Plus Versand',
  amazon_veraltet: 'Amazon-Ernte älter als 48 h',
  amazon_ernte_fehlt: 'Amazon-Angebot ohne Ernte',
  amazon_preis_fehlt: 'Amazon-Preis fehlt',
}

/**
 * Preis A2b: Rollout-Gründe (error_message, Tick-Aktion, History-Grund) im Klartext; null = kein A2-Grund.
 * Präfix `code: detail` wie im Backend.
 */
export function a2GrundText(grund: string | null | undefined): string | null {
  if (!grund) return null
  const i = grund.indexOf(':')
  const code = i < 0 ? grund : grund.slice(0, i)
  const detail = i < 0 ? '' : grund.slice(i + 1).trim()
  const klammer = detail ? ` (${detail})` : ''
  switch (code) {
    case 'exkl_gesperrt': return `Plus Versand gesperrt: ${(TEXT[detail] ?? detail).replace(/^Plus Versand: /, '') || 'Versandbetrag unbekannt'}`
    case 'exkl_neu_starten': return 'Plus Versand: mit neuem Ziel neu starten'
    case 'paritaet_amazon': return `Gesamtpreis unter Amazon${klammer}`
    case 'paritaet_unbekannt': return `Amazon-Preis unbekannt – Parität nicht prüfbar${detail ? ` (${AMAZON_UNBEKANNT[detail] ?? detail})` : ''}`
    case 'paritaet_ceiling': return `Amazon-Gesamt liegt über dem Höchstpreis${klammer}`
    case 'paritaet_angehoben': return 'auf Amazon-Gesamt angehoben'
    case 'wartet_auf_kanaele': return `wartet: erst andere Kanäle anheben${detail ? ` (${PORTAL[detail] ?? detail})` : ''}`
    case 'paritaet_amazon_blockiert': return `Amazon wartet seit über 7 Tagen auf ${PORTAL[detail] ?? (detail || 'einen Kanal')} – bitte prüfen`
    case 'versand_geaendert': return 'Versand geändert – mit neuem Ziel neu gestartet'
    case 'versand_vorgemerkt': case 'versand_geaendert_erkannt': return 'Versand geändert – wartet auf die nächste Ernte'
    case 'exkl_a2_ziel': return 'Ziel gesetzt (A2)'
    default: return null
  }
}
